<script>
import api from '@/helpers/api'
export default {
  name: 'user-form-dialog.app',
  props: {
    visible: { type: Boolean, default: false },
    userId: { type: String },
    customerId: { type: String }
  },
  data: () => ({
    user: {
      preferences: {}
    },
    isLoading: false
  }),
  methods: {
    reset () {
      this.user = {
        customer_id: this.customerId,
        preferences: {}
      }
    },
    onCancel () {
      this.$emit('update:visible', false)

      this.$nextTick(() => {
        this.reset()
      })
    },
    async init () {
      if (this.isUpdate) {
        let item = await api.users.fetch({
          id: this.userId
        })

        this.user = { ...item }
      } else
        this.address = {
          customer_id: this.customerId
        }
    },
    async onSave () {
      let valid = true

      if (valid) {
        try {
          let item
          this.isLoading = true
          if (this.isUpdate) {
            item = await api.users.update({
              ...this.user,
              id: this.userId,
              name: `${this.user.firstname} ${this.user.lastname}`
            })

            let pref = await api.users.updatePreference({
              id: this.userId,
              option: 'allowed_shops',
              value: this.user.preferences.allowed_shops
            })
          } else {
            item = await api.users.create({
              customer_id: this.customerId,
              ...this.user,
              name: `${this.user.firstname} ${this.user.lastname}`
            })
          }
          this.isLoading = false

          this.$emit('created', item)
          this.onCancel()
        } catch (err) {
          this.isLoading = false
        }
      }
    }
  },
  watch: {
    userId: { handler: 'init', immediate: true },
    visible: {
      handler (v) {
        if (v) this.init()
        else this.reset()
      }
    }
  },
  computed: {
    isUpdate () {
      return !!this.userId
    },
    title () {
      return this.isUpdate ? 'Edit User' : 'New User'
    },
    saveBtnLabel () {
      return this.isUpdate ? 'Save Changes' : 'Create User'
    }
  }
}
</script>
<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="lg"
  >
    <b-form-group
      label="First Name"
      label-for="user_name"
      label-cols-sm="4"
      label-cols-lg="2"
    >
      <b-form-input
        id="user_name"
        v-model="user.firstname"
        type="text"
        required
        autocomplete="user_name"
        placeholder="full name"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="Last Name"
      label-for="user_name"
      label-cols-sm="4"
      label-cols-lg="2"
    >
      <b-form-input
        id="user_name"
        v-model="user.lastname"
        type="text"
        required
        autocomplete="user_name"
        placeholder="full name"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="Email"
      label-for="user_email"
      label-cols-sm="4"
      label-cols-lg="2"
    >
      <b-form-input
        id="user_email"
        v-model="user.email"
        type="text"
        autocomplete="user_email"
        placeholder="ex. name@company.com"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="Customer"
      label-for="customer_id"
      label-cols-sm="4"
      label-cols-lg="2"
    >
      <app-customer-select v-model="user.customer_id" id="customer_id" />
    </b-form-group>
    <b-form-group
      label-for="is_active"
      label-cols-sm="4"
      label-cols-lg="2"
      class="d-flex align-items-center"
    >
      <template v-slot:label>
        <div class="d-flex align-items-center pointer">
          Is Active
        </div>
      </template>
      <b-form-checkbox
        switch
        size="lg"
        id="is_active"
        v-model="user.is_active"
        name="is_active"
        inline
      ></b-form-checkbox>
    </b-form-group>

    <b-form-group
      label="Allowed Shops"
      label-for="allowed_shops"
      label-cols-sm="4"
      label-cols-lg="2"
    >
      <app-shop-select
        id="allowed_shops"
        v-model="user.preferences.allowed_shops"
      />
    </b-form-group>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end" style="width: 100%">
        <div>
          <b-button variant="link" @click="onCancel" class="mr-2"
            >Cancel</b-button
          >
          <b-btn variant="primary" class="btn-label" @click="onSave">
            <i class="bx bxs-save label-icon"></i>
            {{ saveBtnLabel }}
          </b-btn>
        </div>
      </div>
    </template>
  </b-modal>
</template>
